module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-3.1b75e9ed.png";